import { gql } from 'graphql-tag'

const questionFragment = gql`
  fragment QuestionFragment on Question {
    id
    question
    active
  }
`

export const getActiveStationQuestionsQuery = gql`
  query GetActiveStationQuestionsQuery($stationId: ID!) {
    getActiveStationQuestionsQuery(stationId: $stationId) {
      ...QuestionFragment
    }
  }
  ${questionFragment}
`
